module.exports = __webpack_public_path__ + "img/icon-MA-Details.e5d746ae.png";